"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlTextWithTooltip = exports.SelectButtonTextLabel = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../Grid/cellRenderers/helpers");
const layouts_1 = require("../../../layouts");
const Text_1 = require("../../../Text");
const Text_2 = require("../../../Text/Text");
const Tooltip_1 = require("../../../Tooltip");
const DEFAULT_MAX_WIDTH_TOOLTIP = '720px';
exports.SelectButtonTextLabel = (0, styled_components_1.default)(Text_2.Text) ``;
const ControlTextWithTooltip = ({ disabled, error, controlText, hasTruncate = true }) => {
    const ref = (0, react_1.useRef)(null);
    return (0, Tooltip_1.useTooltip)({
        maxWidth: DEFAULT_MAX_WIDTH_TOOLTIP,
        renderContent: () => react_1.default.createElement(helpers_1.TooltipText, { size: Text_1.TEXT_SIZE.s }, controlText),
        isActive: hasTruncate,
        render: (tooltipProps) => {
            return (react_1.default.createElement(layouts_1.GrowView, null,
                react_1.default.createElement(exports.SelectButtonTextLabel, Object.assign({}, tooltipProps, { ref: ref, view: (disabled && Text_1.TEXT_VIEW.secondary) ||
                        (error && Text_1.TEXT_VIEW.error) ||
                        Text_1.TEXT_VIEW.link, truncate: hasTruncate, onMouseEnter: (0, helpers_1.onMouseEnterHandlerDecorator)(tooltipProps.onMouseEnter, ref), onMouseLeave: tooltipProps.onMouseLeave }), controlText)));
        }
    });
};
exports.ControlTextWithTooltip = ControlTextWithTooltip;
//# sourceMappingURL=ControlTextWithTooltip.js.map